import { render, staticRenderFns } from "./SelectQ.vue?vue&type=template&id=268544f4&"
import script from "./SelectQ.vue?vue&type=script&lang=ts&"
export * from "./SelectQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports